<template>
  <div class="box box-info">
    <div class="p-grid">
      <div class="p-col">
        <a href="#" @click.prevent="exportCSV()" v-if="this.itemMasterLists.length > 0">
          <img src="../../../../static/img/excel.png"
               style="height: 3.5em;width: 3.5em;float: right;margin-right: 1em;"/>
        </a>
      </div>
    </div>
    <DataTable
      :value="itemMasterLists"
      :paginator="true" ref="po"
      :rowsPerPageOptions="[100,500,1000]"
      :rows="100" :filters="filters"
      editMode="cell"
      class="p-datatable-responsive p-datatable-gridlines"
      :resizableColumns="true" columnResizeMode="fit"
    >
      <Column header="S.N">
        <template #body="sl">
           {{sl.index+1}}
        </template>
      </Column>

      <Column headerStyle="width: 16em" header="Name" field="name" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
      <Column header="Code" field="itemCode" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
        </template>
      </Column>

      <Column header="Unit" field="unitName" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['unitName']"/>
        </template>
      </Column>
      <Column header="Purchase Rate" bodyStyle="text-align: right" :sortable="true" field="purchaseRate"
              filterMatchMode="contains">
        <template #editor="slotProps">
          <InputText v-model="slotProps.data['purchaseRate']" @change="updatePurchaseSalesRate(slotProps.data)"/>
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['purchaseRate']"/>
        </template>
      </Column>
      <Column header="Sales Rate" bodyStyle="text-align: right" :sortable="true" field="salesRate"
              filterMatchMode="contains">
        <template #editor="slotProps">
          <InputText v-model="slotProps.data['salesRate']" @change="updatePurchaseSalesRate(slotProps.data)"/>
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['salesRate']"/>
        </template>
      </Column>
      <template #empty>No record found</template>
    </DataTable>
    <Dialogs header="View Image " :modal="true"
             :visible.sync="imageDialog" :style="{width: '50vw'}">
      <div>
        <Carousel :value="images">
          <template #item="slotProps">
            <!-- {{slotProps.data.name}} -->
            <div class="product-item">
              <div class="product-item-content">
                <div class="p-mb-3">
                  <img :src="slotProps.data.name" style="height:250px;width:250px" class="product-image"/>
                </div>
              </div>
            </div>
          </template>
        </Carousel>
      </div>
    </Dialogs>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteItemMaster"/>
    <!-- </div> -->
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import Dialogs from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Carousel from 'primevue/carousel'
import Button from 'primevue/button'

export default {
  name: 'itemMasterList',
  data() {
    return {
      dialogShow: false,
      itemId: '',
      loading: false,
      imageDialog: false,
      filters: {},
      index: 0,
      images: null
    }
  },
  computed: {
    itemMasterLists() {
      return this.$store.state.itemMaster.itemMasterLists
    }
  },
  mounted() {
    this.itemMasterList()
    this.columnNames()
  },
  methods: {
    async itemMasterList() {
      await this.$store.dispatch('loadItemMasterList')
    },
    async deleteItemMaster(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        itemId: this.itemId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteItemMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editItemMaster(data) {
      this.$emit('edit-item', data)
    },
    viewImage(imageList) {
      this.images = imageList
      this.imageDialog = true
    },
    viewQr(data) {
      this.$router.push({name: 'Qrcode', params: {qrData: data}})
    },
    async updatePurchaseSalesRate(data) {
      let userData = {
        itemId: data.id,
        purchaseRate: data.purchaseRate,
        salesRate: data.salesRate
      }
      let resp = await this.$store.dispatch('updatePurchaseSalesRate', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.ecommerceStatusDialog = false
      }
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Item List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'itemList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.itemId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Dialogs,
    Carousel,
    Button
  }
}
</script>

<style>
.p-datatable table {
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  column-gap: inherit;
}

._message {
  width: fit-content;
  float: right;
  margin-top: -2%;
  margin-right: 1%;
}

.overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  cursor: pointer;
}

.loadingImg {
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
}

.product-item {

.product-item-content {
  border: 1px solid var(--surface-d);
  border-radius: 3px;
  margin: .3rem;
  text-align: center;
  padding: 2rem 0;
}

.product-image {
  width: 50%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}

}
</style>



// WEBPACK FOOTER //
// itemMasterListForRates.vue?1964d6d0